import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { RnOrganizationsProfileVM } from '../../../services/rnapi2-service/models/models';

@Injectable({
  providedIn: 'root'
})
export class BillingSeparationModalService extends BaseModalService<RnOrganizationsProfileVM> {}
